// UserProvider.js
import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import UserContext from "./UserContext";
import * as apicall from "../Apicall";

const UserProvider = ({ children }) => {
  const [vendor, setVendor] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchVendorData = useCallback(async (vendorId) => {
    if (!vendorId) {
      setVendor(null);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      console.log("vendorId------", vendorId);
      const response = await apicall.get(`get_vendor_details?id=${vendorId}`);
      if (
        response.success &&
        Array.isArray(response.data) &&
        response.data.length > 0
      ) {
        const vendorData = response.data[0];
        let services = response.data?.map((ele) => {
          return {
            service_icon: ele?.service_icon,
            service_id: ele?.service_id,
            service_name: ele?.service_name,
          };
        });
        console.log("services---", services);
        localStorage.setItem("services", JSON.stringify(services));
        // Keep userDetails in sync so components reading it directly get the correct vendor data
        // Only when there is a profile: JSON.stringify(undefined) would store the text "undefined",
        // which breaks every JSON.parse of userDetails.
        if (vendorData) localStorage.setItem("userDetails", JSON.stringify(vendorData));

        setVendor(vendorData);
      } else {
        setVendor(null);
      }
    } catch (err) {
      console.error("Fetch error:", err);
      setVendor(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // const vendorId = localStorage.getItem('vendorId');
    const userId = localStorage.getItem("userId");
    fetchVendorData(userId);

    const handleStorageChange = (e) => {
      if (e.key === "userId") {
        fetchVendorData(e.newValue);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [fetchVendorData]);

  const refreshVendorData = useCallback(() => {
    // const vendorId = localStorage.getItem("vendorId");
    const userId = localStorage.getItem("userId");
    fetchVendorData(userId);
  }, [fetchVendorData]);

  const contextValue = useMemo(
    () => ({
      vendor,
      loading,
      refreshVendorData,
    }),
    [vendor, loading, refreshVendorData]
  );

  return (
    <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
  );
};

export default UserProvider;
